import ReactModal from "react-modal";
import './index.css';

export default function ModalConfirmation({state, setState, stateName, custom, title, action, param}){
    function verifyAction(){
        if(param !== ''){
            return action(param)
        }

        return action();
    }

    function closeModal(){
        setState((prevState) => ({...prevState, [stateName]: false}));
    }

    return (
        <ReactModal
            isOpen={state}
            onRequestClose={() => setState((prevState) => ({...prevState, [stateName]: true}))}
            overlayClassName="modal-overlay"
            className="modal-confirmation"
        >
            <h1 className="modal__title">{title}?</h1>
            <div className="modal__buttons">
                <button className="modal___button" onClick={() => {verifyAction(); closeModal()}}>Confirmar</button>
                <button className="modal___button" id="button-close" onClick={() => closeModal()}>Fechar</button>
            </div>
        </ReactModal>
    )
}